<!-- ======= Blog Section ======= -->
<section id="blog" class="blog" style="padding-top: 170px;background-color: #f5f5f5;">
  <div class="container">

    <!-- <ngx-shimmer-loading [shape]="'rect'" [width]="'100%'" [height]="'500px'" *ngIf="blogs===undefined"></ngx-shimmer-loading> -->

    <div class="row" *ngIf="blogs!==undefined">
      <div class="col-lg-8 entries" data-aos="fade-up" data-aos-delay="200">
        <article class="entry entry-single" (click)="goToDetailsPage(blogs.id)">
          <div class="entry-img">
            <img [src]="blogs.image" alt="" class="img-fluid">
          </div>

          <h2 class="entry-title">
            <a (click)="goToDetailsPage(blogs.id)">{{blogs.heading}}</a>
          </h2>

          <div class="entry-meta">
            <ul>
              <li class="d-flex align-items-center"><i class="fa fa-user"></i> <a>{{blogs.by}}</a></li>
              <li class="d-flex align-items-center"><i class="fa fa-clock-o"></i> <a>{{blogs.date}}</a></li>
              <!-- <li class="d-flex align-items-center"><i class="fa fa-folder"></i> <a>{{blogs.category}}</a></li> -->
            </ul>
          </div>
          <div class="entry-content">
            <p [innerHtml]="blogs.smalldescription">
            </p>

            <p [innerHtml]="blogs.fulldescription | noSanitize">
            </p>
          </div>
        </article><!-- End blog entry -->

      </div><!-- End blog entries list -->

      <div class="col-lg-4" data-aos="fade-left" data-aos-delay="200">

        <div class="sidebar">
          <div class="sidebar-item btn-form">
            <button class="form-control" (click)="gotosafetypage()"><i class="fa fa-folder-open"></i>&nbsp;&nbsp;Blog
              Page</button>
          </div>
        </div>

        <!-- <div class="sidebar">
          <h3 class="sidebar-title">Categories</h3>
          <div class="sidebar-item categories">
            <ul>
              <li *ngFor="let cat of objCategory" (click)="onCheckboxClick(cat.category)"><a>{{cat.category}}</a></li>              
            </ul>
          </div>
        </div> -->

        <div class="sidebar">
          <h3 class="sidebar-title">Recent Posts</h3>
          <div class="sidebar-item recent-posts">
            <div class="post-item clearfix" *ngFor="let blog of recentPost">
              <img [src]="blog.image" alt="">
              <h4><a (click)="goToDetailsPage(blog.id)">{{blog.heading}}</a></h4>
              <time datetime="2020-01-01">{{blog.date}}</time>
            </div>
          </div>

        </div>
      </div><!-- End blog sidebar -->

    </div>

  </div>
</section><!-- End Blog Section -->